import { InputNumber, Radio, Select } from "antd";
import React, { useState } from "react";
import { Input } from "antd";
const { TextArea } = Input;

function MedOralMinox({ value, setValue, month, setMonth }) {
  const onChange = (e) => {
    const { name, value } = e.target;
    setValue((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  };

  const onSelectChange = (value) => {
    setValue((prev) => {
      return {
        ...prev,
        reason: value,
      };
    });
  };

  const optionList = [
    {
      label: "Pregnant or planning to get pregnant women",
      value: "Pregnant or planning to get pregnant women",
    },
    {
      label: "Breastfeeding & lactating mothers",
      value: "Breastfeeding & lactating mothers",
    },
    { label: "Under the age of 18", value: "Under the age of 18" },
    { label: "Allergic to Minoxidil", value: "Allergic to Minoxidil" },
    {
      label: "Have low blood pressure/hypotension",
      value: "Have low blood pressure/hypotension",
    },
    {
      label: "Prone to cardiac illnesses",
      value: "Prone to cardiac illnesses",
    },
    { label: "Diabetic", value: "Diabetic" },
    { label: "Have cholesterol", value: "Have cholesterol" },
    {
      label: "Those having thyroid issues",
      value: "Those having thyroid issues",
    },
    {
      label:
        "Undergone a bypass or any other cardiac surgery (including pacemaker etc.)",
      value:
        "Undergone a bypass or any other cardiac surgery (including pacemaker etc.)",
    },
    { label: "Obese individuals", value: "Obese individuals" },
    { label: "45+ aged people", value: "45+ aged people" },
    { label: "None of the above", value: "None of the above" },
  ];

  return (
    <div className="d-flex flex-column gap-2">
      <div className="border border-1 px-1 rounded">
        <div className="my-1 font-poppins">Does the cx need oral minox ?.</div>
        <Radio.Group
          onChange={onChange}
          name="need_oral-minoxidil"
          value={value["need_oral-minoxidil"]}
        >
          <Radio value="Yes">Yes</Radio>
          <Radio value="No">No</Radio>
        </Radio.Group>
      </div>
      {value["need_oral-minoxidil"] == "Yes" && (
        <div>
          <div>
            <TextArea
              placeholder="Define the Need to switch them on oral minox."
              autoSize={{
                minRows: 2,
                maxRows: 6,
              }}
              name="oral_minox_need"
              value={value["oral_minox_need"]}
              onChange={onChange}
            />
          </div>
          <div className="border p-2 mt-2 rounded">
            <div className="my-1 font-poppins">
              Has the patient given verbal consent for Oral Minox?.
            </div>
            <Radio.Group
              onChange={onChange}
              name="minoxidil-consent"
              value={value["minoxidil-consent"]}
            >
              <Radio value="Yes">Yes</Radio>
              <Radio value="No">No</Radio>
            </Radio.Group>
          </div>
          {value["minoxidil-consent"] == "Yes" && (
            <div>
              <div className="mt-2">
                <TextArea
                  placeholder="Baseline BP reading "
                  autoSize={{
                    minRows: 2,
                    maxRows: 6,
                  }}
                  name="baseline-bp"
                  value={value["baseline-bp"]}
                  onChange={onChange}
                />
              </div>
              <div className="mt-2">
                <Select
                  mode="tags"
                  style={{ width: "100%" }}
                  placeholder="Select If there is any of the below conditions"
                  onChange={onSelectChange}
                  name="reason"
                  options={optionList}
                />
              </div>
              <div className="mt-2">
                <div className="border p-2 rounded">
                  <div className="my-1 font-poppins">
                    Can it still be prescribed to the patient.
                  </div>
                  <Radio.Group
                    onChange={onChange}
                    name="can_be-prescribed"
                    value={value["can_be-prescribed"]}
                  >
                    <Radio value="Yes">Yes</Radio>
                    <Radio value="No">No</Radio>
                  </Radio.Group>
                </div>
              </div>
              <div className="py-2 mt-2">
                <InputNumber
                  min={1}
                  max={10}
                  width={100}
                  placeholder="Please select month for Oral Minox."
                  className="w-100"
                  value={month}
                  onChange={(value) => setMonth(value)}
                />
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default MedOralMinox;
